import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

import { checkSecurity } from 'components/config/Security';

import Content from 'components/page/Content/Content';
import { TrainingProvider } from "context/ContextTraining";
import { TrainingSearchProvider } from 'context/ContextTrainingSearch';

import TrainingDetails from '../TrainingDetails';
import TrainingSearchBlock from './TrainingSearchBlock';
import TrainingSessionBlock from './TrainingSessionBlock';

import 'styles/TrainingSearch.css';

const TrainingSearch = () => {
  const navigate = useNavigate();


  useEffect(() => {
    // CHECK SECURITY
    checkSecurity(navigate, 'TrainingSearch');
  }, []);


  return (
    <Content>
      <TrainingProvider>
        <TrainingSearchProvider>
          <TrainingDetails />
          <div>
            <div className="trainingSession">
              <TrainingSessionBlock />
            </div>
            <div className="trainingSearch">
              <TrainingSearchBlock />
            </div>
          </div>
        </TrainingSearchProvider>
      </TrainingProvider>
    </Content>
  );
}

export default TrainingSearch;